import React from "react"
import ScheduleScreen from "./ScheduleScreen/ScheduleScreen"

export default function ScheduleEditorScreen() {
  return <ScheduleScreen isEditable={true} />
}
